$(document).ready(function () {
	'use strict';
	// navbar js start ---
	$(window).on('load scroll', function () {
		var scrolling = $(this).scrollTop();
		if (scrolling > 10) {
			$('.navbar').addClass('nav-fixed')
		} else {
			$('.navbar').removeClass('nav-fixed')
		}
	})

	$(".ham-menu").click(function (event) {
		event.stopPropagation();
		$(".nav-link-wrapper").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".nav-link-wrapper-inner").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".mobile-menu-close-window-btn").click(function (event) {
		event.stopPropagation();
		$(".nav-link-wrapper").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".nav-link-wrapper-inner").toggleClass("active");
		$("body").toggleClass("active");
	});

	// mobile-dropdown responsive accordion js start--
	$(function () {
		let isMobile = window.matchMedia("only screen and (max-width: 992px)").matches;

		if (isMobile) {
			$(".dropdown-sub-menu").slideUp();
			// **..mobile-dropdown-accordion js start..**
			$('.dropdown-btn1').on('click', function () {
				$(this).next(".dropdown-sub-menu1").slideToggle();
				$(this).toggleClass('active');
			});
			// **..mobile-dropdown-accordion js end..**

			// **..mobile-dropdown-accordion js start..**
			$('.dropdown-btn2').on('click', function () {
				$(this).next(".dropdown-sub-menu2").slideToggle();
				$(this).toggleClass('active');
			});
			// **..mobile-dropdown-accordion js end..**
		}
	});
	// mobile-dropdown responsive accordion js end--

	$(".search-bar-open-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(".search-bar-window-close-btn").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".search-bar-window-close-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(this).toggleClass("active");
		$("body").toggleClass("active");
		$("#ajax-search-results").addClass("d-none");
	});

	$(".search-close-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(".search-bar-window-close-btn").toggleClass("active");
		$("body").toggleClass("active");
		$("#ajax-search-results").addClass("d-none");
	});

	// navbar js end ---

	// cart-sidebar js start---
	$(".cart-sidebar-open-btn").click(function (event) {
		event.preventDefault();
		event.stopPropagation();
		$(".cart-sidebar").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".cart-sidebar-close-window-btn").click(function (event) {
		event.preventDefault();
		event.stopPropagation();
		$(".cart-sidebar").removeClass("active");
		$("body").toggleClass("active");
	});

	$(document).on('click', '.side-cart-close-btn', function(event) {
		event.preventDefault();
		event.stopPropagation();
		$('.cart-sidebar').toggleClass('active');
		$('body').toggleClass('active');
	});

	// cart-sidebar js end---

	// filter sidebar js start--
	$(".filter-open-btn").click(function (event) {
		event.stopPropagation();
		$(".collection-filter").addClass('active');
		$("body").toggleClass('active');
	});

	$(".filter-window-close-btn").click(function (event) {
		event.stopPropagation();
		$(".collection-filter").removeClass('active');
		$("body").toggleClass('active');
	});

	$(".filter-close-btn").click(function (event) {
		event.stopPropagation();
		$(".collection-filter").removeClass('active');
		$("body").toggleClass('active');
	});
	// filter sidebar js end--

	// **..filter-accordion js start..**
	$('.accordion-toggle-btn').on('click', function () {
		$(this).next().slideToggle();
		$(this).parent().toggleClass('active');
	});
	// **..filter-accordion js end..**

	// **..faq-accordion js start..**
	$('.faq-accordion-toggle-btn').on('click', function () {
		$(this).next().slideToggle();
		$(this).parent().toggleClass('active');
		$(this).parent().siblings().removeClass('active').find('.faq-accordion-item-content').slideUp();
	});
	// **..product-accordion js end..**

	// --tab js start--
	$('.tab-nav-item:first-child').addClass('active');
	$('.desktop-tab-content-item').hide();
	$('.desktop-tab-content-item:first').show();

	$('.desktop-tabs-nav-item-link').click(function () {
		$('.tab-nav-item').removeClass('active');
		$(this).parent().addClass('active');
		$('.desktop-tab-content-item').hide();

		var activeTab = $(this).attr('href');
		$(activeTab).fadeIn();
		return false;
	});
	// --tab js end--


	// product quantity js start --//
	
	// Add to Cart - product card
	

})

function ajaxAdd(){
	$('.addToCart').on('click', function(e){
        e.preventDefault();

        $.ajax({
            type:'POST',
            url:'/cart/add.js',
            // data:$('#product_form').serialize(),
            data:$(this).closest('#product_form').serialize(),
            dataType:'json',
            success:function(data) {
                $(".cart-sidebar").toggleClass("active");
				$("body").toggleClass("active");
                cart_drawer_update();
            },
            error:function(err) {
                console.log('Error', err);
            }
        })
    })		
}

function qtyUpdate() {
	$(".quantity-increase").click(function () {
		$(".quantity-total").val(parseInt($(".quantity-total").val()) + 1);
	});

	$(".quantity-decrease").click(function () {
		var currentValue = parseInt($(".quantity-total").val());
		if (currentValue > 1) {
			$(".quantity-total").val(currentValue - 1);
		}
	});
}


// btn js ---
// primary btn---
$(function () {
	$('.primary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});

// secondary btn--
$(function () {
	$('.secondary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});
// btn js ---

// banner slider js start--
var swiper = new Swiper(".banner-slider", {
	slidesPerView: 1,
	grabCursor: true,
	loop: true,
	speed: 1000,
	effect: "fade",
	autoplay: {
		delay: 3500,
		disableOnInteraction: false,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});
// banner slider js end--

// card-img-slider js start--
var swiper = new Swiper(".card-img-slide", {
	slidesPerView: 4,
	spaceBetween: 20,
	grabCursor: true,
	loop: false,
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			spaceBetween: 10,
			slidesPerView: 1.5,
			navigation: false
		},
		// when window width is >= 576px
		576: {
			spaceBetween: 10,
			slidesPerView: 2.2,
			navigation: false
		},
		// when window width is >= 767px
		768: {
			spaceBetween: 20,
			slidesPerView: 3.4,
			navigation: false
		},
		// when window width is >= 767px
		993: {
			spaceBetween: 20,
			slidesPerView: 4,
			navigation: true
		}
	}
});
// card-img-sliderr js end--


// product-slider js end---

// related-product slider js start--
var swiper = new Swiper(".related-product-slider", {
	slidesPerView: 4,
	spaceBetween: 20,
	grabCursor: true,
	loop: false,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			spaceBetween: 10,
			slidesPerView: 2,
		},
		// when window width is >= 576px
		576: {
			spaceBetween: 10,
			slidesPerView: 2.2,
		},
		// when window width is >= 767px
		768: {
			spaceBetween: 20,
			slidesPerView: 3.4,
		},
		// when window width is >= 767px
		993: {
			spaceBetween: 20,
			slidesPerView: 4,
		}
	}
});
// related-product slider js end--

// side-cart-slider js start--
var swiper = new Swiper(".side-cart-slider", {
	slidesPerView: 2.2,
	spaceBetween: 10,
	grabCursor: true,
	loop: false,
	speed: 1000,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	}
});
// side-cart-slider js end--

 function initQuickViewScripts() {
        // product-slider js start---
          var swiper = new Swiper(".product-slider-thumb", {
            loop: true,
            spaceBetween: 20,
            slidesPerView: 5,
            freeMode: true,
            mousewheel: true,
            breakpoints: {
              // when window width is >= 320px
              1: {
                spaceBetween: 10,
                slidesPerView: 4,
              },
              // when window width is >= 576px
              576: {
                spaceBetween: 20,
                slidesPerView: 5,
              },
              // when window width is >= 767px
              768: {
                spaceBetween: 20,
                slidesPerView: 5,
              }
            }
          });
          var swiper2 = new Swiper(".product-slider", {
            loop: true,
            autoHeight: true,
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            thumbs: {
              swiper: swiper,
            },
            on: {
              slideChange: function () {
                // Pause all videos in non-active slides
                document.querySelectorAll('.product-slider .swiper-slide video').forEach(video => {
                  video.pause();
                  video.currentTime = 0;
                });

                // Stop YouTube/Vimeo iframes (optional)
                document.querySelectorAll('.product-slider .swiper-slide iframe').forEach(iframe => {
                  try {
                    iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                  } catch (e) {
                    // Ignore errors for cross-domain iframes
                  }
                });
              }
            }
          });



      let variants = [];

      $("#productSelect option").each(function () {
        let variant = {
          id: $(this).val(),
          title: $.trim($(this).text()),
          available: $(this).data("available"),
          image: $(this).data("img"),
          price: $(this).data("price"),
          compare_at_price: $(this).data("compare"),
          options: $.trim($(this).text()).split("-")
        };
        variants.push(variant);
      });

      $(".option_input").on("change", function () {
        let selectedOptions = [];
        var opt = $(this).val();
        $(this).closest('.product-varient').find('.selected_option').text(opt);

        $("input:radio.option_input:checked").each(function () {
          selectedOptions.push($(this).val());
        });

        let selectedTitle = selectedOptions.join("-");

        $("#productSelect option").each(function () {
          if ($.trim($(this).text()) === selectedTitle) {
            let img = $(this).data("img");
            let id = $(this).val();
            let price = $(this).data('price');
            let available = $(this).data("available");

            $("#productSelect").val(id);
            $("#product_id").val(id);
            $(".latest-price strong").text(price);

            if (available) {
              $(".atc-text").text("Add To Cart");
              $(".addToCart").removeClass("sold_out");
            } else {
              $(".atc-text").text("Sold Out");
              $(".addToCart").addClass("sold_out");
            }

            $(".thumb_img").each(function (index) {
              let src = $(this).attr("src").split("?")[0];
              let cleanImg = img?.split("?")[0];

              if (src === cleanImg) {
                swiper2.slideToLoop(index, 500, false);
                $(".thumb_img").removeClass("active");
                $(this).closest(".thumb_img").addClass("active");
              }
            });
          }
        });

        // Disable unavailable options
        $(".option_input").each(function () {
          let $input = $(this);
          let currentVal = $input.val();
          let optionIndex = parseInt($input.data("option-index"));

          let testOptions = [...selectedOptions];
          testOptions[optionIndex] = currentVal;

          let isAvailable = variants.some(function (variant) {
            return variant.available && variant.options.every(function (opt, idx) {
              return testOptions[idx] === opt;
            });
          });

          // if (!isAvailable) {
          //   $input.prop("disabled", true).closest(".product-varient-input-field").addClass("disabled");
          // } else {
          //   $input.prop("disabled", false).closest(".product-varient-input-field").removeClass("disabled");
          // }
        });
      });

      // Trigger once on page load
      $(".option_input:checked").trigger("change");

    }

  $(document).ready(function () {
      initQuickViewScripts();
      qtyUpdate();
      ajaxAdd();
  });

// bundle 

$(document).ready(function() {
    $('.bundle_item').on('change', function() {
        let price = 0;
		selectedProducts = [];

        $('.bundle_item:checked').each(function() {
			let id = $(this).val();  
            price += Number($(this).data('price'));
			selectedProducts.push(id);
        });
		
		$('#total_price').text(price);
		$('.product_ids').val(selectedProducts.join(','));

		
		let size = $('.bundle_item:checked').length;
		$('.total_count').text(size);
		if(size > 0) {
			$('.bundle_add').removeClass('disabled')
		}else{
			$('.bundle_add').addClass('disabled')
		}

    });

	$('.bundle_add').on('click', function(e){
		e.preventDefault();
		let ids = $('.product_ids').val();
        if(ids === ""){
            alert("Please select at least one product.");
            return;
        }
        let idArray = ids.split(',');

		// Build items array
		let items = idArray.map(function(variantId){
			return {
				id: Number(variantId),
				quantity: 1
			};
		});

		$.ajax({
			type:'POST',
			url:'/cart/add.js',
			// data:$('#product_form').serialize(),
			data: {items },
			dataType:'json',
			success:function(data) {
				$(".cart-sidebar").toggleClass("active");
				$("body").toggleClass("active");
				cart_drawer_update();

			},
			error:function(err) {
				console.log('Error', err);
			}
		})
    })

	$('.quick_view').on('click', function(event){
        // console.log('click');
        var handle = $(this).data('handle')
        const qvURL = `${window.shopUrl}/products/${handle}`;
		
        // console.log('qvURL ' + qvURL);
        const qvContent = document.querySelector('#quickview_content');  
        fetch(`${qvURL}?view=qv`)
        .then((response) => response.text())
        .then((responseText) => {     
            var product_info = $(responseText, 'text/html');
            var single_product = $('.product-page-content-wrap', product_info);
            $(qvContent).html('');
            $(qvContent).append(single_product);
            console.log('work ')

			initQuickViewScripts();
			qtyUpdate();
			ajaxAdd();
			
        })
        .catch(err => {
            console.log(err);
        });
        $('.bundle-modal').addClass('show');
    })

    
    $('.modal-close-button, .modal-overly').on('click', function(){
        $('.bundle-modal').removeClass('show');
        $('#quickview_content').empty(); 
    })
});



// progress-bar js start--
document.addEventListener('DOMContentLoaded', function () {
  const progress = document.querySelector('.progress');
  if (progress) {
    progress.addEventListener('input', function () {
      const value = this.value;
      this.style.background = `linear-gradient(to right, rgb(36, 40, 51) 0%, rgb(36, 40, 51) ${value}%, rgb(216, 216, 216) ${value}%)`;
    });
  }
});

// content animation--
new WOW().init();



function cart_drawer_update() {
    fetch('/?section_id=cart-drawer')
        .then(reponse => reponse.text())
        .then(cartData => {
            var cart_html = $(cartData);
            var cart_items = $('.cart-sidebar-box', cart_html);
            var cart_footer = $('.side-cart-product-content-footer', cart_html);
            var cart_progress = $('.side-cart-progress-bar-area', cart_html);
            $('.cart-sidebar-box').replaceWith(cart_items);
            $('.side-cart-product-content-footer').replaceWith(cart_footer);
            $('.side-cart-progress-bar-area').replaceWith(cart_progress);
    });

    $.getJSON('/cart.js', function(cart){
        var total_items = cart.item_count;
		$('.side-cart-item-number').text(cart.item_count);
        if(total_items > 0){
            $('.cart-item-count').removeClass('d-none');
            $('.cart-item-count').text(total_items);
        }else{
            $('.cart-item-count').addClass('d-none');
        }
    })
}

// cart item increase
function itemPlus(e, el) {
	var id = $(el).data('id');
	var qty = $(el).prev().val();
	qty = parseInt(qty) + 1;
	
	$.ajax({
		type : "POST",
		url:'/cart/change.js',
		data: {
			id: parseFloat(id),
			quantity: qty
		},
		dataType:'json',
		success:function(data) {
			cart_drawer_update();
			$('.item-quantity').val(qty);
			// console.log('Increased');
		},
		error:function(err) {
			console.log('Error')
		}
	})
}
// cart item decrease
function itemMinus(e, el) {
	var id = $(el).data('id');
	var qty = $(el).next().val();
	qty = parseInt(qty) - 1;

	$.ajax({
		type : "POST",
		url:'/cart/change.js',
		data: {
			id: parseFloat(id),
			quantity: qty
		},
		dataType:'json',
		success:function(data) {
			cart_drawer_update();
			if(qty >= 1) {
				$('.item-quantity').val(qty);
			}
		},
		error:function(err) {
			console.log('Error')
		}
	})
}
// cart item decrease
function itemRemoved(e, el) {
	var id = $(el).data('id');
	$.ajax({
		type : "POST",
		url:'/cart/change.js',
		data: {
			id: parseFloat(id),
			quantity: 0
		},
		dataType:'json',
		success:function(data) {
			cart_drawer_update();
		},
		error:function(err) {
			console.log('Error')
		}
	})
}




// cart item increase
function cartItemPlus(e, el) {
  var id = $(el).data("id");
  var qty = $(el).prev().val();
  qty = parseInt(qty) + 1;
  console.log("qty " + qty);
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: qty,
    },
    dataType: "json",
    success: function (data) {
      cart_page_update();
      $(el).prev().val(qty);
    },
    error: function (err) {
      console.log("Error");
    },
  });
}
// cart Page item decrease
function cartItemMinus(e, el) {
  var id = $(el).data("id");
  var qty = $(el).next().val();
  qty = parseInt(qty) - 1;
  if (qty >= 1) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: parseFloat(id),
        quantity: qty,
      },
      dataType: "json",
      success: function (data) {
        cart_page_update();
        $(el).next().val(qty);
      },
      error: function (err) {
        console.log("Error");
      },
    });
  }
}
// cart item removed
function cartItemRemoved(e, el) {
  var id = $(el).data("id");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: 0,
    },
    dataType: "json",
    success: function (data) {
      cart_page_update();
    },
    error: function (err) {
      console.log("Error");
    },
  });
}

// cart item update
function cart_page_update() {
  fetch("/?section_id=cart-items")
    .then((reponse) => reponse.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_empty = $(".cart-empty", cart_html);
      var cart_items = $(".cart-table", cart_html);
      var cart_order_summary = $(".cart-order-summary", cart_html);
      $(".cart-empty").replaceWith(cart_empty);
      $(".cart-table").replaceWith(cart_items);
      $(".cart-order-summary").replaceWith(cart_order_summary);
    });

  $.getJSON('/cart.js', function(cart){
        var total_items = cart.item_count;
		$('.side-cart-item-number').text(cart.item_count);
        if(total_items > 0){
            $('.cart-item-count').removeClass('d-none');
            $('.cart-heading').removeClass('d-none');
            $('.cart-item-count').text(total_items);
        }else{
            $('.cart-item-count').addClass('d-none');
            $('.cart-heading').addClass('d-none');
        }
    })
}

// ========================= cart Page End ====================

